var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{staticClass:"relative",attrs:{"name":"fade","mode":"out-in"}},[(!_vm.product)?_c('ProductsDetailSkeleton'):_c('ProductsDetail',{attrs:{"product":_vm.product}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }